import { useEffect } from "react";
import { EventEmitter } from "eventemitter3";

const emitter = new EventEmitter();

/*
    event: name of the event being subscribed to 
    callback: function executed when event triggered
*/
export const useSub = (event: any, callback: (...args: any[]) => void) => {
    const unsubscribe = () => {
        emitter.off(event, callback);
    };

    useEffect(() => {
        emitter.on(event, callback);
        return unsubscribe;
    }, []);

    return unsubscribe;
};

/*
    event: name of the event being published 
    data: optional data associated with the event
*/
export const usePub = () => {
    return (event: any, data?: any) => {
        emitter.emit(event, data);
    };
};

export enum EventNames {
    OpenPopup = "event_openPopup",
    OpenSidebar = "event_openSidebar",
    UpdateImageViewerActiveIndex = "event_updateImageViewerActiveIndex",
    UpdateImageViewerMode = "event_updateImageViewerMode",
    SetImageViewerOpen = "event_setImageViewerOpen",
    SetImageViewerOpenWithCompletionEvent = "event_setImageViewerOpenWithCompletionEvent",
    ImageViewerOpenCompletionEvent = "event_imageViewerOpenUpdated",
}
